import { useAuth } from '../../services/AuthService';
import { useContext, useEffect, useState } from 'react';
import { useLogger } from '../../services/LogService';
import { AppContext } from '../../state/AppContextProvider';
import { WPService } from '../../services/WPService';

interface AxiosInterceptorsProps { children }

const AxiosInterceptors: React.FC<AxiosInterceptorsProps> = ({ children }) => {
  const { state, dispatch } = useContext(AppContext);

  const logger = useLogger('AxiosInterceptors');

  const auth = useAuth();

  const [ isReady, setReady ] = useState(false);

  useEffect(() => {
    logger.info("Init WP Service Axios interceptors");
    const wp = WPService.getInstance(logger, auth);
    wp.initAxiosInterceptors(state, dispatch);
    setReady(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isReady ? children : <></>;
};

export default AxiosInterceptors;
